import React from 'react'
import { Subtitle, TitleContainer, Title, Container, WemolonIcon } from './NotFound.style'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { BUTTON_KIND, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons/types'
import Button from 'parkdepot-shared/components/Buttons/Button'
import { homeRoute } from '../Home/route.const'

const NotFound = () => {
    const { t } = useTranslation()
    const { replace } = useHistory()

    const onHomeClick = () => {
        replace(homeRoute())
    }

    return (
        <Container>
            <TitleContainer>
                <WemolonIcon className="wemolo-wemolon" aria-hidden="true" />
                <Title>{t('404.redTitle')}</Title>
                <Subtitle>{t('404.redText')}</Subtitle>
            </TitleContainer>

            <Button id="404-home-button" $kind={BUTTON_KIND.primary} $size={BUTTON_SIZE.medium} onClick={onHomeClick}>
                {t('404.redButtonText')}
            </Button>
        </Container>
    )
}

export default NotFound
